import React from 'react';

const ItemList = ({ children }) => (
  <div className='items'>
    {children}
  </div>
);

export default ItemList;
